export default __webpack_public_path__ + "static/media/loading.2cbf9358.svg";